export const AUTHENTICATED ="IS_AUTH";
export const ROLE= "ROLE";
export const BUSINESS_ID="BUSINESS_ID";
export const SHOW_MODAL="SHOW_MODAL";
export const TIME_OUT="TIME_OUT";
export const USER_EMAIL="USER_EMAIL";
export const HB_ROUTE="hb";
export const HOME_ROUTE="home";
export const SPS_ROUTE="sps";

export const APP_URL = window.location.protocol + "//" + window.location.host

export function getLocalStorageItem(key){
    const v= window.localStorage.getItem(key);
    if(v){
        try{
        const value= JSON.parse(v);
        return value;
        } catch{
             return null;
        }
    }
}
export function setLocalStorageItem(key,data){
    window.localStorage.setItem(key,JSON.stringify(data));
}

export function removeLocalStorageItem(key){
    window.localStorage.removeItem(key)
}